export default __webpack_public_path__ + "static/media/club-bg-sm.953aade3.svg";